import { withInstall } from '@bigin/utils'

import Pagination from './src/pagination'

export const BPagination = withInstall(Pagination)
export default BPagination

export * from './src/pagination'
